import React from "react";
import styles from "./styles/progress-bar.module.scss";
import useProgressData from "@/components/pages/convert/hooks/use-progress-data";
import CancelButton from "@/components/pages/convert/components/cancel-button";
import { DescriptionCode } from "@/data/description-codes.data";

type ProgressBarProps = {
  percent: number;
  descriptionCode: DescriptionCode;
  onCancel?: () => void;
  isCancelling?: boolean;
};

const ProgressBar = ({
  percent,
  descriptionCode,
  onCancel,
  isCancelling,
}: ProgressBarProps) => {
  const { displayPercent, descriptionMessage } = useProgressData(
    percent,
    descriptionCode,
  );
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.description}>{descriptionMessage}</div>
        <div className={styles.progress_wrapper}>
          <div className={styles.progress_bar}>
            <div
              className={styles.progress}
              style={{ width: `${displayPercent}%` }}
            />
          </div>
          <div className={styles.progress_text}>{displayPercent}%</div>
        </div>
      </div>
      {onCancel && isCancelling !== undefined && (
        <div className={styles.cancel_button_wrapper}>
          <CancelButton onCancel={onCancel} isCancelling={isCancelling} />
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
